import Button from "../../../../ui/Button/Button";
import styles from "./Header.module.scss";

function Header({
  title,
  titleElement,
  description,
  isDisabled,
  isDirty,
  isSubmitting,
  onCancel,
  saveButtonText = "Save",
}: {
  title: string;
  titleElement?: React.ReactNode;
  description?: React.ReactNode;
  isDisabled?: boolean;
  isDirty: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  saveButtonText?: string;
}) {
  return (
    <div className={styles.header}>
      <div className={styles.headerText}>
        <div className={styles.titleRow}>
          <h2 className={styles.title}>{title}</h2>
          {titleElement}
        </div>
        {description &&
          (typeof description === "string" ? (
            <p className={styles.description}>{description}</p>
          ) : (
            <div className={styles.description}>{description}</div>
          ))}
      </div>
      <Button
        variant="outline"
        disabled={!isDirty || isSubmitting || isDisabled}
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        type="submit"
        loading={isSubmitting}
        disabled={isSubmitting || !isDirty || isDisabled}
      >
        {saveButtonText}
      </Button>
    </div>
  );
}

export default Header;
